import { useNavigate } from "react-router-dom";
import { AnimateOnScroll } from "../../../components/animate";
import { Button } from "../../../components/buttons/button";

export const FindEventsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="relative w-full overflow-hidden">
      <div className="relative z-[1] bg-transparent pt-[72px] md:pt-[124px]">
        <div className="max-width">
          <div className="mx-auto flex w-full max-w-[453px] flex-col items-center justify-center gap-4 text-center">
            <AnimateOnScroll
              animation="fade-up"
              delay={0.25}
              className="flex flex-col items-center justify-center text-center"
            >
              <>
                <img
                  src="/assets/images/sparkles.png"
                  alt="sparkles"
                  className="mb-4 block max-w-[32px] md:max-w-[49px]"
                />
                <h1 className="website-title">
                  Find Event is
                  <br />
                  Coming Soon
                </h1>
              </>
            </AnimateOnScroll>

            <AnimateOnScroll animation="fade-up" delay={0.75}>
              <p className="website-title-text">
                We’d let you know when you this feature is available.
              </p>
            </AnimateOnScroll>

            <AnimateOnScroll animation="fade-up" delay={1}>
              <Button
                text="Back to Home"
                onClick={() => {
                  navigate("/");
                }}
                type="button"
                variation="primary"
                className="glossy-button mt-4 max-w-fit !px-[20px] !py-4"
              />
            </AnimateOnScroll>
          </div>
        </div>
      </div>

      <AnimateOnScroll
        animation="fade-up"
        delay={0.5}
        className="absolute inset-0 block h-full w-full object-cover object-bottom md:object-contain"
      >
        <img
          src="/assets/images/search.png"
          className="h-full w-full object-cover object-bottom md:object-contain"
          alt="search"
        />
      </AnimateOnScroll>
    </div>
  );
};
